import PopNotification from './PopNotification.component';
export type { PopNotificationProps } from './PopNotification.component';

export default PopNotification;
